<template>
  <vue-select
    style="margin: 10px 0 0;"
    label="airport"
    id="select-border"
    :filterable="false"
    v-model="selectedAirport"
    :getOptionLabel="getOptionLabel"
    :filter=filter
    :options="options"
    @search="handleKeywords"
    @change="handleChange"
    :clearable="false"
    :placeholder="placeholder">
    <template slot="option" slot-scope="option">
      <slot name="selected-option" v-bind="(typeof option === 'object')?option:{[label]: option}">
        {{ getOptionLabel(option) }}
      </slot>
    </template>
    <div slot="no-options" id="no-options">{{ $t('Please write airport name') }}</div>
  </vue-select>
</template>

<script>
import { VueSelect } from 'vue-select'
import _ from 'lodash'
import { searchKeyword } from '../util'

export default {
  name: 'AirportSelector',
  components: { VueSelect },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    'default-airport': {
      type: String
    }
  },
  data () {
    return {
      selectedAirport: null,
      airports: [],
      options: [],
      airportField: 'en',
      filter (options, search) {
        this.$emit('keywords', search)
      }
    }
  },
  mounted () {
    let lang = ['en', 'jp', 'ru']
    let locale = (this.$i18n.locale)
    this.airportField = locale.split('-')[0] ? locale.split('-')[0] : 'en'
    if (lang.indexOf(this.airportField) === -1) {
      this.airportField = 'en'
    }
    let url = `/airports-${this.airportField}.json`
    this.$http.get(url).then(resposne => {
      this.airports = resposne.data.sort((a, b) => a.code < b.code)
      if (this.defaultAirport) {
        let option = this.airports.find(a => a.code === this.defaultAirport)
        if (option) {
          this.selectedAirport = option
        }
      }
    })
  },
  methods: {
    getOptionLabel (option) {
      return option['code'] + '--' + option['airport']
    },
    handleChange (option) {
      this.$emit('selected', option)
    },
    handleKeywords (search) {
      this.keywords = search
      this.debouncedKeywords()
    },
    debouncedKeywords: _.debounce(function () {
      this.search()
    }, 200),
    search () {
      this.options = searchKeyword(this.airports, this.keywords, this.airportField)
    }
  }
}
</script>

<style lang="scss">
.van-cell-group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 7px;
  height: 56px;
  border-bottom: 1px solid #d8d8d8;
}
  #select-border {
    width: 100%;

    .dropdown-toggle {
      width: 100%;
    }
    input {
      margin: 0;
      border: 0;
    }

    input[type=search] {
      border: 0;
    }
    input::placeholder {
      font-size: 16px;
      color: #999;
    }

    .dropdown-toggle {
      padding: 0;
      border: none;
      border-radius: 0;

      .open-indicator {
        border: 0;
        &:before {
          border: 0;
        }
      }
      .vs__selected-options {
        overflow: hidden;
        padding: 0;

        .selected-tag {
          position: absolute;
          top: -1px;
          font-size: 16px;
          border: none;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .vs__actions {
        padding: 0;
        width: 0;
        height: 0;;
      }
    }
  }
</style>
